<div class="justify-center px-[20px] pb-[20px] pt-[10px]" isOpen="true">
  <!-- <ion-content> -->
    <div class="flex flex-col items-center gap-[10px]">
      <div class="relative w-full flex items-center justify-center py-2">
        <button
          class="absolute top-0 right-0 text-3xl font-bold text-gray-600 hover:text-black"
          (click)="cancel()"
          aria-label="Close"
        >
          &times;
        </button>

        <ark-lib-icon-name name="alert" class="text-2xl"></ark-lib-icon-name>
      </div>
      <div>
        <h3 class="text-center">Are you sure you want to block this Member?</h3>
        <div class="text-center mt-[10px]">&#64;{{userNickname}}</div>
        <div class="text-center mt-[20px] px-[30px] text-[16px] leading-[26px] text-[#14192D] font-normal">If blocked, you will not be able to view their content.</div>
      </div>

      <ark-button 
        class="h-[48px] w-[240px] mt-[15px]"
        type="delete"
        rightIcon="system-block"
        (click)="confirm()"
      >BLOCK</ark-button>

      <ark-button
      classess="h-[48px] w-[100px]"
      type="light"
      leftIcon="system-left"
      [iconColor]="'#14192D'"
      class="h-[48px] w-[100px]"
      (click)="cancel()"
      >Cancel</ark-button>
    </div>
  <!-- </ion-content> -->
</div>